import { UpdateSpecs } from "./UpdateSpecs";

export default UpdateSpecs;
